import React from 'react'
import { ReportMethodsHooks } from './report-hooks'
import Content from 'blocks.app/content/content'
import Stick from 'blocks.simple/stick/stick'
import Catalog from 'blocks.app/catalog/catalog'
import ScheduleSetting from 'blocks.app/scheduleSettings/scheduleSettings'
import Button from 'blocks.simple/button/button'
import ScrollUp from 'blocks.simple/scrollUp/scrollUp'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './report.jcss'
import { grid } from '../../theme'
import moment from 'moment'
import helpers from 'core/helpers'
import { Typography } from 'atoms/Typography'
import { Steps } from 'atoms/Steps/Steps-view'
import { getURLSearchParamsByLocation, getURLSearchParamsString } from 'features/routes/utils'
import { checkAvailableModule } from '../../core/helpers/routes/routes'
import Dropdown from '../../blocks.simple/dropdown/dropdown'
import { changeLocation } from '../../features/routes'

type Location = {
    pathname: string
    search: string
    hash: string
    state: any
}

const Report = ({ location }: { location: Location }) => {
    const query = getURLSearchParamsByLocation(location)
    const reportType = query.reportType || 'displays'
    const {
        reports,
        report,
        period,
        setStartDate,
        setEndDate,
        setStartTime,
        setEndTime,
        setMailReport,
        setDevicesReportType,
        setReportView,
        setReportItems,
        getReportItems,
        getTitle,
        submit,
        setPeriod,
        selectPeriod,
        subSteps,
        onSelectSubStep,
        selectedSubStep,
        onSelectStep,
        getMultiSelectTitle,
        getSelectTypeRequestOptions,
    } = ReportMethodsHooks(location)

    const subStepIsDisabled = (step: string) => {
        if (step === 'broadcasts') {
            return !report.devices.length
        }
        if (step === 'files') {
            return !report.devices.length || !report.broadcasts.length
        }

        return false
    }

    const onSelect = (selectedItems: any) => {
        const query = getURLSearchParamsByLocation(location)
        const reportType = query.reportType === 'multipleSelect' ? selectedSubStep : query.reportType || 'displays'
        setReportItems(reportType, selectedItems)
    }

    const getReportTypeOptions = (reportType: string) => {
        let options: { name: string; id: string }[] = []

        if (reportType === 'multipleSelect') {
            options = [{ name: translate('selectPlaybackContent'), id: 'selectPlaybackContent' }]
        } else {
            switch (reportType) {
                case 'displays':
                    options = [
                        { name: translate('playingContent'), id: '' },
                        { name: translate('operationOfDevices'), id: 'digitalSignageStatusReport' },
                        { name: translate('qualityAssessmentReport'), id: 'qualityAssessmentReport' },
                        { name: translate('videoAnalyticsReport'), id: 'videoAnalyticsReport' },
                    ]
                    break
                case 'files':
                    options = [{ name: translate('folderReport'), id: 'folderReport' }]
                    break
                case 'broadcasts':
                    options = [{ name: translate('broadcastReport'), id: 'broadcastReport' }]
                    break
                case 'advertisingCampaigns':
                    options = [{ name: translate('advertisingCampaignReport'), id: 'advertisingCampaignReport' }]
                    break
                case 'photoBoothSurveyReport':
                    options = [{ name: translate('photoBoothSurveyReport'), id: 'photoBoothSurveyReport' }]
                    break
                case 'licenseReport':
                    options = [{ name: translate('licenseReport'), id: 'licenseReport' }]
                    break
                case 'currencyReport':
                    options = [{ name: translate('currencyReport'), id: 'currencyReport' }]
                    break
                case 'yandexWeatherReport':
                    options = [{ name: translate('yandexWeatherReport'), id: 'yandexWeatherReport' }]
                    break
                case 'yandexJamReport':
                    options = [{ name: translate('yandexJamReport'), id: 'yandexJamReport' }]
                    break
                case 'advertisingAds':
                    options = [{ name: translate('advertisingAdsReport'), id: 'advertisingAdsReport' }]
                    break
                default:
                    options = []
            }
        }

        if (reportType === 'displays' && window.spconfig.totalCostReportEnabled) {
            options.push({
                name: translate('totalCostReport'),
                id: 'totalCostReport',
            })
        }

        return options
    }

    const getReportViewOptions = (reportType: string) => {
        let options

        if (reportType === 'multipleSelect') {
            options = [{ name: translate('reportViewContentPlayQuantity'), id: 'contentPlayQuantity' }]
        } else {
            options = [{ name: translate('reportViewDefault'), id: 'default' }]
        }

        if (reportType === 'displays' && report.devicesReportType === 'digitalSignageStatusReport') {
            options.push({ name: translate('reportViewConditionNow'), id: 'conditionNow' })
        }

        return options
    }

    return (
        <Content
            // toolbar={
            //     reportType === 'currencyReport' ||
            //     reportType === 'licenseReport' ||
            //     reportType === 'photoBoothSurveyReport' ? null : (
            //         <ReportToolbar location={location} selectedStep={selectedStep} selectedSubStep={selectedSubStep} />
            //     )
            // }
            title={translate('reports')}
            wrapperClassName={styles.reportsWrapper}
        >
            <div className={styles.reportWrapper}>
                {reportType !== 'currencyReport' &&
                    reportType !== 'photoBoothSurveyReport' &&
                    reportType !== 'licenseReport' &&
                    reportType !== 'yandexWeatherReport' &&
                    reportType !== 'yandexJamReport' && (
                        <div>
                            <Steps className={styles.tabs} active={reportType}>
                                {reports
                                    .map((reportItem, index) => {
                                        if (
                                            !helpers.isAvailable({ key: reportItem.id, action: 'read' }) &&
                                            reportItem.id !== 'multipleSelect'
                                        ) {
                                            return null
                                        }
                                        return (
                                            <div
                                                id={reportItem.id}
                                                key={`reportTab_${index}`}
                                                // to={{
                                                //     pathname: location.pathname,
                                                //     search: getURLSearchParamsString({ reportType: reportItem.id }),
                                                // }}
                                                onClick={() => {
                                                    onSelectStep(reportItem.id)
                                                    changeLocation({
                                                        location: location.pathname,
                                                        search: getURLSearchParamsString({ reportType: reportItem.id }),
                                                    })
                                                }}
                                            >
                                                {reportItem.name}
                                            </div>
                                            // <Link
                                            //     id={reportItem.id}
                                            //     key={`reportTab_${index}`}
                                            //     to={{
                                            //         pathname: location.pathname,
                                            //         search: getURLSearchParamsString({ reportType: reportItem.id }),
                                            //     }}
                                            //     onClick={() => {
                                            //         console.log(selectedStep)
                                            //         console.log(reportItem.id)
                                            //         onSelectStep(reportItem.id)
                                            //     }}
                                            // >
                                            //     {reportItem.name}
                                            // </Link>
                                        )
                                    })
                                    .filter((step) => step)}
                            </Steps>
                        </div>
                    )}
                <form onSubmit={(e) => submit({ e, reportType: reportType })}>
                    <div className={styles.whiteBlock}>
                        <Typography className={grid.mb_mdPlus} type="text">
                            {translate('reportParams')}
                        </Typography>
                        <ScheduleSetting
                            startDate={{
                                label: translate('startDate'),
                                dateValue: moment(report.startDate),
                                id: 'startDate',
                                maxDate: moment(report.endDate),
                            }}
                            onChangeStartDate={(startDate: string) => {
                                setPeriod('other')
                                setStartDate(moment(startDate).toDate().getTime())
                            }}
                            endDate={{
                                label: translate('endDate'),
                                id: 'endDate',
                                minDate: moment(report.startDate),
                                dateValue: moment(report.endDate),
                            }}
                            onChangeEndDate={(endDate: string) => {
                                setPeriod('other')
                                setEndDate(moment(endDate).toDate().getTime())
                            }}
                            period={{
                                mod: 'default',
                                label: translate('period'),
                                value: period,
                                options: [
                                    { name: translate('day'), id: 'day' },
                                    { name: translate('week'), id: 'week' },
                                    { name: translate('month'), id: 'month' },
                                    { name: translate('anyPeriod'), id: 'other' },
                                ],
                            }}
                            onPeriodChange={selectPeriod}
                            startTime={{
                                label: translate('startTime'),
                                id: 'startTime',
                                type: 'tel',
                                mask: '99:99:99',
                                value: report.startTime,
                                noFocus: true,
                            }}
                            onChangeStartTime={(value: any) => {
                                if (moment(value, 'HH:mm:ss', true).isValid()) {
                                    const startMs = moment(value, 'HH:mm:ss').unix()
                                    const endMs = moment(report.endTime, 'HH:mm:ss').unix()

                                    if (startMs < endMs) {
                                        setStartTime(value)
                                        setPeriod('other')
                                    }
                                }
                            }}
                            endTime={{
                                label: translate('endTime'),
                                id: 'endTime',
                                type: 'tel',
                                mask: '99:99:99',
                                value: report.endTime,
                                noFocus: true,
                            }}
                            onChangeEndTime={(value: any) => {
                                if (moment(value, 'HH:mm:ss', true).isValid()) {
                                    const startMs = moment(report.startTime, 'HH:mm:ss').unix()
                                    const endMs = moment(value, 'HH:mm:ss').unix()

                                    if (startMs < endMs) {
                                        setEndTime(value)
                                        setPeriod('other')
                                    }
                                }
                            }}
                            checkbox={{
                                label: translate('sendToEmail'),
                                checked: report.mailReport,
                            }}
                            onChecked={(mailReport: boolean) => {
                                setMailReport(mailReport)
                            }}
                        />
                    </div>
                    <div className={cn(grid.mb_md, styles.paddingMobile)}>
                        <div className={cn(grid.row, grid.mt_mini, grid.mb_mini, styles.typeAndView)}>
                            <div className={styles.dropdownWrapper}>
                                <Dropdown
                                    value={report.devicesReportType}
                                    options={getReportTypeOptions(reportType)}
                                    label={translate('reportType')}
                                    onChange={(selected) => {
                                        setDevicesReportType(selected.id)

                                        if (selected.id !== 'digitalSignageStatusReport') {
                                            setReportView('default')
                                        }
                                    }}
                                />
                            </div>
                            <div className={styles.dropdownWrapper}>
                                <Dropdown
                                    value={report.reportView}
                                    options={getReportViewOptions(reportType)}
                                    label={translate('reportView')}
                                    onChange={(selected) => {
                                        setReportView(selected.id)
                                    }}
                                />
                            </div>
                            <div className={styles.dropdownWrapper} />
                        </div>
                    </div>
                    {reportType && <div className={grid.mt_md} />}
                    <Stick enabled={true}>
                        <div className={cn(grid.rowCenter, grid.p_micro)}>
                            <Button type="submit" mod="fill">
                                {translate('createReport')}
                            </Button>
                        </div>
                    </Stick>
                </form>
                {reportType !== 'multipleSelect' &&
                    reportType !== 'currencyReport' &&
                    reportType !== 'photoBoothSurveyReport' &&
                    reportType !== 'licenseReport' &&
                    reportType !== 'yandexWeatherReport' &&
                    reportType !== 'yandexJamReport' && (
                        <>
                            <Typography type="title" className={styles.title}>
                                {getTitle(location)}
                            </Typography>
                            <div className={styles.report__catalog}>
                                {helpers.isAvailable({ key: reportType, action: 'read' }) && (
                                    <Catalog
                                        key={`catalog_${reportType}`}
                                        type={reportType === 'advertisingAds' ? 'advertisingCampaigns' : reportType}
                                        searchbarMod={'withShadow'}
                                        selectedItems={getReportItems(reportType)}
                                        onSelect={onSelect}
                                    />
                                )}
                            </div>
                        </>
                    )}
                {(reportType === 'yandexWeatherReport' || reportType === 'yandexJamReport') && (
                    <>
                        <Typography type="title" className={styles.title}>
                            {getTitle(location)}
                        </Typography>
                        <div className={styles.report__catalog}>
                            {helpers.isAvailable({ key: 'displays', action: 'read' }) && (
                                <Catalog
                                    key={`catalog_displays`}
                                    type={'displays'}
                                    searchbarMod={'withShadow'}
                                    selectedItems={report.devices}
                                    onSelect={onSelect}
                                />
                            )}
                        </div>
                    </>
                )}
                {reportType === 'multipleSelect' && (
                    <div className={styles.subStepsWrapper}>
                        <div className={styles.subStepsTitle}>{translate('selectStepByStep')}</div>
                        <div className={styles.subSteps}>
                            {subSteps.map((step) => {
                                return (
                                    <div
                                        className={cn(
                                            styles.subStep,
                                            selectedSubStep === step.id ? styles.subStepSelected : '',
                                            subStepIsDisabled(step.id) ? styles.disabled : ''
                                        )}
                                        onClick={() => {
                                            onSelectSubStep(step.id)
                                            changeLocation({
                                                location: location.pathname,
                                                search: step.id + '&reportType=multipleSelect',
                                            })
                                        }}
                                    >
                                        {step.name}
                                    </div>
                                )
                            })}
                        </div>
                        <div>
                            <Typography type="title" className={styles.title}>
                                {getMultiSelectTitle(selectedSubStep)}
                            </Typography>
                            <div className={styles.report__catalog}>
                                <Catalog
                                    key={`catalog_${selectedSubStep}`}
                                    type={selectedSubStep}
                                    searchbarMod={'withShadow'}
                                    selectedItems={getReportItems(selectedSubStep)}
                                    onSelect={onSelect}
                                    customOptions={getSelectTypeRequestOptions(selectedSubStep)}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <ScrollUp />
        </Content>
    )
}

const exportReport = checkAvailableModule('reports') ? Report : null

export default exportReport
